import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState = {
  exercises: [],
  exerciseHashMap: {},
}

// whichWeightCache Slice
const whichWeightCache = createSlice({
  name: 'whichWeightCache',
  initialState,
  reducers: {
    setWhichWeightCacheExercises: (state, action) => {
      state.exercises = action.payload.exercises
      state.exerciseHashMap = action.payload.exerciseHashMap
    },
    clearWhichWeightCache: () => initialState
  },
});

export const {
  setWhichWeightCacheExercises,
  clearWhichWeightCache 
} = whichWeightCache.actions;

export default whichWeightCache.reducer;